// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"77a0bd5c","453":"9b5440d6","546":"5ae6b9a7","854":"a3cf3db1","862":"68a81ba1"}[chunkId] + ".chunk.js";
};